function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

const trapFocusHandlers = {};

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function trapFocus(container, elementToFocus = container) {
	const elements = getFocusableElements(container);
	const first = elements[0];
	const last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = () => {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = (event) => {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"pauseVideo","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => {
		video.pause();
	});
	document.querySelectorAll("product-model").forEach((model) => {
		model.modelViewerUI.pause();
	});
}

window.pauseAllMedia = pauseAllMedia;

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });
		this.querySelectorAll("button").forEach((button) => {
			button.addEventListener("click", this.onButtonClick.bind(this));
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;
		if (event.target.name === "plus") this.input.stepUp();
		else this.input.stepDown();

		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.get("quantity-input") ||
	customElements.define("quantity-input", QuantityInput); // eslint-disable-line

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	/* eslint-disable no-restricted-syntax */
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	/* eslint-enable no-restricted-syntax */
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		}, // eslint-disable-line
	};
}

/*
 * Shopify Common JS
 *
 */
const Shopify = typeof window.Shopify === "undefined" ? {} : window.Shopify;

Shopify.bind = (fn, scope) => () => fn.apply(scope, _arguments); // eslint-disable-line

Shopify.setSelectorByValue = (selector, value) => {
	// eslint-disable-line
	for (let i = 0, count = selector.options.length; i < count; i += 1) {
		const option = selector.options[i];
		if (value === option.value || value === option.innerHTML) {
			selector.selectedIndex = i; // eslint-disable-line
			return i;
		}
	}
};

Shopify.addListener = (target, eventName, callback) => {
	if (target.addEventListener)
		target.addEventListener(eventName, callback, false);
	else target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = (path, options = {}) => {
	const method = options.method || "post";
	const params = options.parameters || {};

	const form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	/* eslint-disable guard-for-in */
	/* eslint-disable no-restricted-syntax */
	for (const key in params) {
		const hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	/* eslint-enable guard-for-in */
	/* eslint-enable no-restricted-syntax */

	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = (countryDomid, provinceDomid, options) => {
	this.countryEl = document.getElementById(countryDomid);
	this.provinceEl = document.getElementById(provinceDomid);
	this.provinceContainer = document.getElementById(
		options.hideElement || provinceDomid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: () => {
		const value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: () => {
		const value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: () => {
		const opt = this.countryEl.options[this.countryEl.selectedIndex];
		const raw = opt.getAttribute("data-provinces");
		const provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length === 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (let i = 0; i < provinces.length; i += 1) {
				const option = document.createElement("option");
				option.value = provinces[i][0]; // eslint-disable-line
				option.innerHTML = provinces[i][1]; // eslint-disable-line
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: (selector) => {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: (selector, values) => {
		for (let i = 0, _count = values.length; i < values.length; i += 1) {
			// eslint-disable-line
			const opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) => {
			summary.addEventListener("click", this.onSummaryClick.bind(this));
		});
		this.querySelectorAll("button:not(.menu-close)").forEach((button) => {
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
		this.querySelectorAll(".menu-close").forEach((button) => {
			button.addEventListener("click", this.onMenuCloseClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;
		if (openDetailsElement === this.mainDetailsToggle)
			this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"));
		else this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			if (isOpen) this.closeMenuDrawer(summaryElement);
			else this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`,
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut() {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	onMenuCloseClick(event) {
		event.preventDefault();
		this.closeMenuDrawer(event);
		this.mainDetailsToggle
			.querySelector("summary")
			.focus({ preventScroll: true });
	}

	closeSubmenu(detailsElement) {
		detailsElement
			.closest(".menu-drawer__inner-submenu, .menu-drawer__navigation")
			?.classList.remove("noScroll");
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.get("menu-drawer") ||
	customElements.define("menu-drawer", MenuDrawer); // eslint-disable-line

class HeaderDrawer extends MenuDrawer {
	/* eslint-disable no-useless-constructor */
	constructor() {
		super();
	}
	/* eslint-enable no-useless-constructor */

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.getElementById("shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom",
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${Number(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.get("header-drawer") ||
	customElements.define("header-drawer", HeaderDrawer); // eslint-disable-line

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this),
		);
		this.addEventListener("click", (event) => {
			if (event.target.nodeName === "MODAL-DIALOG") this.hide();
		});
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
	}

	show(opener) {
		this.openedBy = opener;
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		this.querySelector(".template-popup").loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
	}

	hide() {
		document.body.classList.remove("overflow-hidden");
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}

customElements.get("modal-dialog") ||
	customElements.define("modal-dialog", ModalDialog); // eslint-disable-line

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");
		if (button) {
			button.addEventListener("click", () => {
				document.querySelector(this.getAttribute("data-modal")).show(button);
			});
		}
	}
}

customElements.get("modal-opener") ||
	customElements.define("modal-opener", ModalOpener); // eslint-disable-line

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (poster) poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();
		}
	}
}

customElements.get("deferred-media") ||
	customElements.define("deferred-media", DeferredMedia); // eslint-disable-line

export {
	trapFocus,
	removeTrapFocus,
	debounce,
	serializeForm,
	fetchConfig,
	ModalOpener,
	ModalDialog,
	DeferredMedia,
};

window.updateCartCount = function updateCartCount() {
	fetch("/cart.js")
		.then((res) => res.json())
		.then((cart) => {
			const headerIcons = document.querySelector(".header__icons");
			if (!headerIcons) return;

			const cartCountWrapper = headerIcons.querySelector("#cart-icon-bubble");
			if (!cartCountWrapper) return;

			const cartCountEl = cartCountWrapper.querySelector(".cart-count-bubble");

			// Create bubble if it doesn't exist and cart has items
			if (!cartCountEl && cart.item_count > 0) {
				const bubble = document.createElement("div");
				bubble.className = "cart-count-bubble";

				const visibleCountEl = document.createElement("span");
				visibleCountEl.setAttribute("aria-hidden", "true");

				const hiddenCountEl = document.createElement("span");
				hiddenCountEl.className = "visually-hidden";

				bubble.appendChild(visibleCountEl);
				bubble.appendChild(hiddenCountEl);

				cartCountWrapper.appendChild(bubble);
			}

			// Remove bubble if cart is empty
			if (cartCountEl && cart.item_count === 0) {
				cartCountEl.remove();
				return;
			}

			const cartBubble = cartCountWrapper.querySelector(".cart-count-bubble");
			if (!cartBubble) return;

			const visibleCount = cartBubble.querySelector('span[aria-hidden="true"]');
			const hiddenCount = cartBubble.querySelector(".visually-hidden");

			if (visibleCount) {
				visibleCount.textContent = cart.item_count;
			}

			if (hiddenCount) {
				hiddenCount.textContent = cart.item_count;
			}
		});
};

document.addEventListener("wk:wishlist:add-to-cart:success", () => {
	window.updateCartCount();
});
